import React from "react";
import { CircularProgressbarWithChildren, buildStyles, } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
export const SnykCircularDepCounter = (depCount) => {
    const directCount = depCount.depCount.directCount;
    const indirectCount = depCount.depCount.indirectCount;
    const total = depCount.depCount.totalCount;
    return (React.createElement(CircularProgressbarWithChildren, { value: total > 0 ? (directCount * 100) / total : 100, strokeWidth: 6, circleRatio: 0.5, styles: buildStyles({
            pathTransitionDuration: 0.5,
            strokeLinecap: "butt",
            pathColor: total > 0 ? "#f00" : "#ABEBC6",
            trailColor: "#eee",
            rotation: 3 / 4,
        }) },
        React.createElement("div", { style: { width: "88%" } },
            React.createElement(CircularProgressbarWithChildren, { value: total > 0 ? (indirectCount * 100) / total : 100, circleRatio: 0.5, strokeWidth: 6, styles: buildStyles({
                    pathTransitionDuration: 0.5,
                    strokeLinecap: "butt",
                    pathColor: total > 0 ? "orange" : "#ABEBC6",
                    trailColor: "#eee",
                    rotation: 3 / 4,
                }) },
                React.createElement("div", { style: { width: "88%" } },
                    React.createElement("div", { style: {
                            position: "absolute",
                            fontSize: 12,
                            marginTop: "-15%",
                            marginLeft: "35%",
                        } },
                        React.createElement("strong", null, directCount),
                        " Direct",
                        React.createElement("br", null),
                        React.createElement("strong", null, indirectCount),
                        " Unique Indirect"))))));
};
//# sourceMappingURL=SnykCircularDepCountersComponent.js.map